import { render } from "./ViewDemandePrixPage.vue?vue&type=template&id=551323ba&ts=true"
import script from "./ViewDemandePrixPage.vue?vue&type=script&lang=ts"
export * from "./ViewDemandePrixPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__